import { create } from 'zustand';
import { apiFetch, reorderGroups as apiReorderGroups } from '../api';
import useAdminAuthStore from './adminAuthStore';

const useGroupsStore = create((set, get) => ({
  groups: [],
  loading: false,
  error: null,
  addResult: null,

  async fetchGroups() {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch('/groups', { token });
      set({ groups: data, loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  async addGroup({ name }) {
    set({ loading: true, error: null, addResult: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch('/groups', {
        method: 'POST',
        body: { name },
        token,
      });
      set({ addResult: data.group, loading: false });
      await get().fetchGroups();
      return data.group;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async deleteGroup(id) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      await apiFetch(`/groups/${id}`, {
        method: 'DELETE',
        token,
      });
      await get().fetchGroups();
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  async updateGroup(id, update) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch(`/groups/${id}`, {
        method: 'PATCH',
        body: update,
        token,
      });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async getGroup(id) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiFetch(`/groups/${id}`, { token });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  clearAddResult() {
    set({ addResult: null });
  }
  ,
  async reorderGroups(orders) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await apiReorderGroups({ orders, token });
      set({ groups: data.groups, loading: false });
      return data.groups;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  }
}));

export default useGroupsStore; 